// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--1-znq";
export const upperContainer = "footer-module--upperContainer--199PL";
export const nhsLogoContainer = "footer-module--nhsLogoContainer--3Yle-";
export const svgBox = "footer-module--svgBox--1r8QA";
export const menu = "footer-module--menu--3RCUA";
export const sccLogoContainer = "footer-module--sccLogoContainer--1CVAp";
export const bottomContainer = "footer-module--bottomContainer--E-LJp";
export const copyright = "footer-module--copyright--1o72R";